import { FormField } from "@ui-kit/Form/FormField";
import { TextInput } from "@ui-kit/TextInput/TextInput";
import { Rule } from "antd/lib/form";
import { useTranslation } from "react-i18next";
interface PasswordFieldProps {
  name?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  autoComplete?: "current-password" | "new-password";
  type?: "current-password" | "new-password" | "confirm-password";
  rules?: Rule[];
  disabled: boolean;
}

export const PasswordField = ({
  name = "password",
  label,
  placeholder,
  required = true,
  type = "current-password",
  autoComplete,
  disabled,
  rules = [],
}: PasswordFieldProps) => {
  const { t } = useTranslation();
  const translationKeyMap = {
    "current-password": "passwordField",
    "new-password": "newPasswordField",
    "confirm-password": "confirmPasswordField",
  };
  const computedAutoComplete =
    autoComplete ?? (type === "confirm-password" ? "new-password" : type);

  const computedRules: Rule[] = [
    ...(required
      ? [
          {
            required: true,
            message: t(`forms.${translationKeyMap[type]}.required`),
          },
        ]
      : []),
    ...rules,
  ];

  return (
    <FormField
      label={label ?? t(`forms.${translationKeyMap[type]}.label`)}
      name={name}>
      <TextInput
        name={name}
        type="password"
        placeholder={
          placeholder ?? t(`forms.${translationKeyMap[type]}.placeholder`)
        }
        size="large"
        rules={computedRules}
        disabled={disabled}
        autoComplete={computedAutoComplete}
      />
    </FormField>
  );
};
